import { passwordValidationRules, MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const CONDITIONS = [
  {
    title: "password-indicator.require.min-max-length",
    id: "min-max-length",
    validator: passwordValidationRules["min-max-length"]()
  },
  {
    title: "password-indicator.require.1-digit",
    id: "number",
    validator: passwordValidationRules.number()
  },
  {
    title: "password-indicator.require.1-symbol",
    id: "symbol",
    validator: passwordValidationRules.symbol()
  },
  {
    title: "password-indicator.require.1-uppercase",
    id: "uppercase",
    validator: passwordValidationRules.uppercase()
  },
  {
    title: "password-indicator.require.1-lowercase",
    id: "lowercase",
    validator: passwordValidationRules.lowercase()
  }
];
let PasswordIndicatorComponent = class extends Mixins(MagicConfigMixin) {
  get currentStatus() {
    return this.filteredConditions.map(({ id, params, validator, title }) => {
      return {
        title,
        params,
        id,
        isValid: validator(this.value || "")
      };
    });
  }
  get filteredConditions() {
    return CONDITIONS.map((condition) => {
      const match = this.conditions.find((cond) => {
        if (typeof cond === "object") {
          return cond.name === condition.id;
        }
        return cond === condition.id;
      });
      if (match) {
        if (typeof match === "object" && match.name === "min-max-length") {
          const min = match.value.min;
          const max = match.value.max;
          return __spreadProps(__spreadValues({}, condition), {
            title: "password-indicator.require.min-max-length.with-params",
            params: { min, max },
            validator: passwordValidationRules["min-max-length"]({
              min,
              max
            })
          });
        }
        return __spreadProps(__spreadValues({}, condition), { params: {} });
      }
      return null;
    }).filter(Boolean);
  }
  get isAllValid() {
    return this.currentStatus.every(({ isValid }) => isValid);
  }
};
__decorateClass([
  Prop(String)
], PasswordIndicatorComponent.prototype, "value", 2);
__decorateClass([
  Prop({
    type: Array,
    default: CONDITIONS.map(({ id }) => id),
    required: false,
    validator: (property) => {
      const available = CONDITIONS.map(({ id }) => id);
      return property.every((condition) => {
        if (typeof condition === "object") {
          return available.includes(condition.name);
        }
        return available.includes(condition);
      });
    }
  })
], PasswordIndicatorComponent.prototype, "conditions", 2);
PasswordIndicatorComponent = __decorateClass([
  Component({
    name: "ui-password-indicator"
  })
], PasswordIndicatorComponent);

export default PasswordIndicatorComponent;
